import React, { useRef } from "react";
import Button from "devextreme-react/button";
import { Popup } from "devextreme-react/popup";
import { TemplateAttachmentsController } from "../hooks/useTemplateAttachmentsController";

export default function TemplateAttachmentsView({
    files,
    canEdit,
    onUploadFile,
    onRemoveFile,
    showRemoveConfirm,
    setShowRemoveConfirm,
    pendingOverwrite,
    confirmOverwrite,
    cancelOverwrite,
}: TemplateAttachmentsController) {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            await onUploadFile(file);
            if (fileInputRef.current) fileInputRef.current.value = "";
        }
    };

    return (
        <div className="etv-app-data">
            {files.length === 0 && !canEdit && (
                <span style={{ color: "#888" }}>No attachments</span>
            )}

            {files.map(filename => (
                <div key={filename}>
                    <span className="etv-app-data-path">{filename}</span>
                    {canEdit && (
                        <i
                            className="dx-icon-trash"
                            title="Remove attachment"
                            onClick={() => setShowRemoveConfirm(filename)}
                            style={{ cursor: "pointer", marginLeft: 8, color: "#888" }}
                        />
                    )}
                </div>
            ))}

            {canEdit && (
                <>
                    <input
                        ref={fileInputRef}
                        type="file"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                    />
                    <a
                        href="#"
                        onClick={(e) => { e.preventDefault(); fileInputRef.current?.click(); }}
                        style={{ fontSize: 12, marginTop: 4, display: "inline-block" }}
                    >
                        Upload file...
                    </a>
                </>
            )}

            <Popup
                visible={showRemoveConfirm != null}
                onHiding={() => setShowRemoveConfirm(null)}
                showCloseButton
                hideOnOutsideClick
                dragEnabled={false}
                title="Remove Attachment"
                width={450}
                height="auto"
                wrapperAttr={{ style: "z-index: 1700" }}
            >
                <div className="etv-confirm-content">
                    <p>Remove <strong>{showRemoveConfirm}</strong> from this notification?</p>
                    <p>The file will remain on the server and can be re-uploaded to other notifications.</p>
                    <div className="etv-confirm-actions">
                        <Button text="Cancel" type="normal" stylingMode="outlined" onClick={() => setShowRemoveConfirm(null)} />
                        <Button text="Remove" type="danger" stylingMode="contained" onClick={() => showRemoveConfirm && onRemoveFile(showRemoveConfirm)} />
                    </div>
                </div>
            </Popup>

            <Popup
                visible={pendingOverwrite != null}
                onHiding={cancelOverwrite}
                showCloseButton
                hideOnOutsideClick
                dragEnabled={false}
                title="Replace File"
                width={450}
                height="auto"
                wrapperAttr={{ style: "z-index: 1700" }}
            >
                <div className="etv-confirm-content">
                    <p>A file named <strong>{pendingOverwrite?.name}</strong> already exists.</p>
                    <p>Do you want to replace it?</p>
                    <div className="etv-confirm-actions">
                        <Button text="Cancel" type="normal" stylingMode="outlined" onClick={cancelOverwrite} />
                        <Button text="Replace" type="default" stylingMode="contained" onClick={confirmOverwrite} />
                    </div>
                </div>
            </Popup>
        </div>
    );
}
